module.exports = __webpack_public_path__ + "static/img/one-sim.89eaadc.png";